import React, { useState } from "react";
import { ChevronLeft, ChevronRight, History } from "lucide-react";
import { IconButton, Chip } from "@/shared/components/ui-kit";
import { ViewerDialog } from "@/shared/components/viewer";
import type { Artifact } from "@/shared/types";

export default function ArtifactViewer({ artifact, onClose = () => {}, mobile: _mobile }: {
  artifact: Artifact; onClose?: () => void; mobile?: boolean;
}) {
  const versions = artifact.versions;
  const last = Math.max(0, (versions?.length || 1) - 1);
  const [pick, setPick] = useState({ id: artifact.id, i: last });
  const at = pick.id === artifact.id ? Math.min(pick.i, last) : last;
  const select = (i: number) => setPick({ id: artifact.id, i });
  const content = versions?.length ? versions[at].content : artifact.content;
  return <ViewerDialog mode="artifact" title={artifact.title + (at < last ? ` — ${versions![at].id}` : "")} content={content} onClose={onClose} description={`${artifact.type} · ${artifact.age}`} toolbar={versions && versions.length > 1 && (
    <div className="min-h-10 shrink-0 flex items-center gap-2 [&_button:disabled]:opacity-40 [&_button:disabled]:pointer-events-none px-4 border-b hairline bg-[var(--surface)]">
      <History size={14} className="text-[var(--text-secondary)]" />
      <IconButton title="Previous version" aria-label="Previous version" disabled={at === 0} onClick={() => select(at - 1)}><ChevronLeft size={14} /></IconButton>
      <span className="font-mono text-[12px] tabular-nums">{versions[at].id}</span>
      <IconButton title="Next version" aria-label="Next version" disabled={at === last} onClick={() => select(at + 1)}><ChevronRight size={14} /></IconButton>
      <span className="text-[12px] text-[var(--text-secondary)] flex-1 truncate">{versions[at].label}</span>
      {at === last ? <Chip tone="success">CURRENT</Chip> : <button onClick={() => select(last)} className="press rounded-[6px] px-2 py-1 text-[12px] hover:bg-[var(--accent-hover)]">Back to current</button>}
    </div>
  )} />;
}
